module.exports = __webpack_public_path__ + "img/a_thousand_brains.5bf5f1f2.png";